import Icon from '../components/Icon.vue'

Icon.register({
  'broadcast-tower': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M150.9 192c-7 0-13.5-4.5-15.4-11.2-4.9-17-7.5-34.6-7.5-52.8s2.6-35.8 7.5-52.8c2-6.7 8.4-11.2 15.4-11.2h33.7c11 0 18.6 10.8 14.9 21.2-4.9 13.6-7.5 28-7.5 42.8s2.6 29.2 7.5 42.8c3.8 10.3-3.9 21.2-14.9 21.2h-33.7zM89.9 23.3c-16.5 31.1-49.6 116 0.2 209.3 5.7 10.6-1.9 23.4-14 23.4h-34.8c-6.2 0-12-3.5-14.6-9.1-23.6-50.5-26.7-94.1-26.7-118.9 0-42.3 9.4-82.5 25.9-118.7 2.6-5.7 8.5-9.3 14.7-9.3h35.3c12 0 19.6 12.7 14 23.3zM614.1 9.3c16.5 36.2 25.9 76.3 25.9 118.7s-9.4 82.5-26 118.7c-2.6 5.7-8.5 9.3-14.7 9.3h-35.2c-12.1 0-19.6-12.8-13.9-23.5 48.1-89.8 18-174.9-0.3-209.2-5.6-10.6 2-23.3 14-23.3h35.4c6.3 0 12.1 3.6 14.7 9.3zM489.1 64c7 0 13.5 4.5 15.4 11.2 4.9 17 7.5 34.6 7.5 52.8s-2.6 35.8-7.5 52.8c-2 6.8-8.4 11.2-15.4 11.2h-33.7c-11 0-18.6-10.8-14.9-21.2 4.9-13.6 7.5-28 7.5-42.8s-2.6-29.2-7.5-42.8c-3.8-10.3 3.9-21.2 14.9-21.2h33.7zM372.8 164.1l130.5 313.4c3.4 8.1-0.5 17.5-8.6 20.9l-29.5 12.3c-8.1 3.4-17.5-0.5-20.9-8.6l-49.2-118.2h-150.1l-49.2 118.2c-3.4 8.1-12.8 12-20.9 8.6l-29.5-12.3c-8.1-3.4-12-12.8-8.6-20.9l130.5-313.4c-7-10.3-11.2-22.7-11.2-36.1 0-35.3 28.6-64 64-64 35.3 0 64 28.7 64 64 0 13.4-4.2 25.8-11.2 36.1zM271.6 320h96.8l-48.4-116.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/broadcast-tower.js
// module id = 1122
// module chunks = 0